import React from 'react';
import { ArrowUp, ArrowRight, ArrowDown } from 'lucide-react';

type Priority = 'high' | 'medium' | 'low';

interface PriorityBadgeProps {
  priority: Priority;
}

const config: Record<Priority, { label: string; className: string; icon: React.ReactNode }> = {
  high: {
    label: 'High',
    className: 'bg-red-50 text-red-600 border-red-200',
    icon: <ArrowUp size={10} />,
  },
  medium: {
    label: 'Medium',
    className: 'bg-amber-50 text-amber-700 border-amber-200',
    icon: <ArrowRight size={10} />,
  },
  low: {
    label: 'Low',
    className: 'bg-gray-50 text-gray-500 border-gray-200',
    icon: <ArrowDown size={10} />,
  },
};

export default function PriorityBadge({ priority }: PriorityBadgeProps) {
  const c = config[priority];
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border ${c.className}`}
    >
      {c.icon}
      {c.label}
    </span>
  );
}